<div class="dialog-container dialog-container--width">
    <div class="dialog-title-block">
        <h2>Mark Consumed?</h2>
        <div class="flex-container gap-2">
            <div class="dialog-btn" (click)="onClose()">
                <img class="dialog-colse-btn" src="../../../assets/images/close.png" alt="close">
            </div>
        </div>
    </div>
    <div class="dialog-content-block p-4">
        <div>
            <p class="text-para text-light-dark">You are about to mark the implant "{{ dialogData.implantName }}" as <span class="text-link text-dark">consumed</span> under your name.</p>
            <p class="mt-3 text-para text-light-dark">Please confirm the store at which the product is consumed</p>
        </div>

        <div (click)="openStoresDropdown($event)" class="cursor-pointer mt-2 px-3 py-2 app-border-grey text-para text-capitalize text-light-dark select-type-input position-relative">
            {{ selectedStore.name !== "" ? selectedStore.name : 'Select' }}
            <div class="position-absolute dropdown-arrow">
              <img src="../../../assets/images/dropdown.svg" alt="arrow" srcset="">
            </div>
            <div id="stores-dropdown" class="w-100 stores-dropdown position-absolute">
              <ul *ngIf="stores.length !== 0">
                <li *ngFor="let store of stores" (click)="onStoreChange(store)">{{ store.name }}</li>
              </ul>
              <ul *ngIf="stores.length === 0">
                <li>No stores available</li>
              </ul>
            </div>
          </div>
    </div>
    <div class="dialog-footer">
        <button class="px-4 py-2" type="button" (click)="onClose()">Cancel</button>
        <button class="px-2 py-2 addproduct" type="submit" (click)="consume()">Mark Consume</button>
    </div>
</div>
